import * as o from "react";
import i from "../lib/IconBase.es.js";
import e from "../defs/SplitHorizontal.es.js";
const t = o.forwardRef((r, a) => /* @__PURE__ */ o.createElement(i, { ref: a, ...r, weights: e }));
t.displayName = "SplitHorizontalIcon";
const m = t;
export {
  m as SplitHorizontal,
  t as SplitHorizontalIcon
};
